var _g, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDropdown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Dropdown",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.037,
    height: 32.037,
    viewBox: "0 0 32.037 32.037",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_270115",
    "data-name": "Group 270115",
    transform: "translate(0 32.037) rotate(-90)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_497567",
    "data-name": "Path 497567",
    d: "M0,0H32.037V32.037H0Z",
    fill: "#356f92"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_497568",
    "data-name": "Path 497568",
    d: "M20.008,28.014a2.321,2.321,0,0,1-1.775-.854l-5.62-6.808a2.8,2.8,0,0,1-.347-2.95A2.359,2.359,0,0,1,14.388,16h11.24a2.359,2.359,0,0,1,2.122,1.4,2.8,2.8,0,0,1-.347,2.95l-5.62,6.808A2.321,2.321,0,0,1,20.008,28.014Z",
    transform: "translate(-3.99 -5.321)",
    fill: "#356f92"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_497569",
    "data-name": "Path 497569",
    d: "M0,0H32.037V32.037H0Z",
    fill: "none"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdown);
export default __webpack_public_path__ + "static/media/Dropdown.b5881e1ebb71eb9ba6bfd0bd69c2e729.svg";
export { ForwardRef as ReactComponent };